export default __webpack_public_path__ + "static/media/mobile-banner.4eeab6af.png";